import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

type ParamsBase = {
  type: string;
  state?: string;
};

type SuccessParams = ParamsBase & {
  type: 'success';
  exchangeCode: string;
};

export type ErrorParams = ParamsBase & {
  type: 'error';
  errorCode: string;
  description?: string;
};

export type OAuth2Params = SuccessParams | ErrorParams;

const useOAuth2Params = () => {
  const router = useRouter();
  const [params, setParams] = useState<OAuth2Params | undefined>(undefined);

  useEffect(() => {
    if (router.isReady) {
      const query = router.query;
      const exchangeCode = query['code'] as string | undefined;
      const errorCode = query['error'] as string | undefined;
      const state = query['state'] as string | undefined;

      if (errorCode) {
        const description = query['error_description'] as string | undefined;

        setParams({ type: 'error', errorCode, description, state });
      } else if (exchangeCode) {
        setParams({ type: 'success', exchangeCode, state });
      }
    }
  }, [router]);

  return params;
};

export default useOAuth2Params;
